export default "__VITE_ASSET__DZSBslNL__"